var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"bottom-2 left-1 absolute pointer",attrs:{"id":"ShowAbout"},on:{"click":function($event){return _vm.$emit('open')}}},[_c('img',{staticClass:"dim",attrs:{"src":require("../assets/wwr.png")}})])}
var staticRenderFns = []

export { render, staticRenderFns }